(function () {
  if (!document.body.classList.contains('template-collection')) return;

  let isInfiniteLoading = false;
  let nextPageURL = null;
  let reinitScheduled = false;

  function bindColorSwatches() {
    const swatches = document.querySelectorAll('.item-image-wrapper:not(.single-swatch)');
    swatches.forEach((swatch) => {
      if (swatch.dataset.swatchBound === 'true') return;
      swatch.dataset.swatchBound = 'true';

      swatch.addEventListener('click', () => {
        const variantColor = swatch.getAttribute('data-value');
        const variantImageId = swatch.getAttribute('data-img-id');
        const variantImg = swatch.getAttribute('data-img');
        const container = swatch.closest('.card-wrapper');
        if (!container) return;

        swatch.closest('.item-swatch')?.querySelectorAll('.item-image-wrapper').forEach((item) => {
          item.classList.remove('active');
        });
        swatch.classList.add('active');

        const firstImage = container.querySelector('.image-first');
        const secondImageEl = container.querySelector('.image-second');
        if (firstImage && variantImg) {
          firstImage.setAttribute('srcset', variantImg);
          firstImage.setAttribute('src', variantImg);
        }

        if (secondImageEl && variantImageId) {
          const filter = `.id-${variantImageId}`;
          const source = swatch.closest('.item-swatch')?.querySelector(filter);
          const secondImage = source?.nextElementSibling?.getAttribute('data-image');
          if (secondImage) {
            secondImageEl.setAttribute('srcset', secondImage);
            secondImageEl.setAttribute('src', secondImage);
          }
        }

        container.querySelectorAll('.quick-cart-add ul li').forEach((sizeItem) => {
          sizeItem.classList.add('hide-variant');
          if (sizeItem.getAttribute('data-show') === variantColor) {
            sizeItem.classList.remove('hide-variant');
          }
        });
      });
    });
  }

  function bindQuickAddOpeners() {
    document.querySelectorAll('.quick-add-cart-wrapper').forEach((item) => {
      if (item.dataset.quickAddBound === 'true') return;
      item.dataset.quickAddBound = 'true';
      item.addEventListener('click', () => {
        item.closest('.card__content')?.querySelector('.quick-cart-add')?.classList.add('active');
      });
    });
  }

  function bindSizeAddToCart() {
    document.querySelectorAll('.quick-cart-add ul li:not(.sold_out)').forEach((item) => {
      if (item.dataset.sizeBound === 'true') return;
      item.dataset.sizeBound = 'true';
      item.addEventListener('click', () => {
        const variantId = item.getAttribute('data-id');
        const card = item.closest('.card-wrapper');
        if (!variantId || !card) return;

        card.classList.add('size-selected');
        card.setAttribute('data-variant-id', variantId);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 422) {
              document.body.classList.add('cart-error-active');
              const popup = document.querySelector('#cart-error-popup');
              if (popup) popup.innerText = data.description;
              setTimeout(() => document.body.classList.remove('cart-error-active'), 3000);
              return;
            }
            if (typeof cartPopupUpdate === 'function') cartPopupUpdate();
            setTimeout(() => {
              document.body.classList.add('cart-popup-active');
              document.body.classList.add('dropdown-shadow');
            }, 500);
          })
          .catch(() => {
            document.body.classList.add('cart-error-active');
            const popup = document.querySelector('#cart-error-popup');
            if (popup) popup.innerText = 'An Error Occured. Please try again later';
            setTimeout(() => document.body.classList.remove('cart-error-active'), 3000);
          })
          .finally(() => {
            setTimeout(() => {
              item.closest('.quick-cart-add')?.classList.remove('active');
              card.style.display = 'block';
              document.body.classList.remove('dropdown-shadow');
            }, 200);
          });
      });
    });
  }

  function initSwipers() {
    document.querySelectorAll('.media-slider').forEach((slider, index) => {
      if (slider._swiperMouseEnterHandler) {
        slider.removeEventListener('mouseenter', slider._swiperMouseEnterHandler);
      }
      if (slider._swiperMouseLeaveHandler) {
        slider.removeEventListener('mouseleave', slider._swiperMouseLeaveHandler);
      }
      if (slider.swiper && typeof slider.swiper.destroy === 'function') {
        slider.swiper.destroy(true, true);
      }

      const swiperInstance = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        grabCursor: true,
        autoplay: false,
      });

      if (index === 0) {
        setTimeout(() => {
          swiperInstance.slideToLoop(1);
          setTimeout(() => swiperInstance.slideToLoop(0), 2000);
        }, 1000);
      }

      slider._swiperMouseEnterHandler = () => {
        swiperInstance.params.autoplay = { delay: 1500 };
        swiperInstance.autoplay.start();
      };
      slider._swiperMouseLeaveHandler = () => {
        swiperInstance.autoplay.stop();
      };

      slider.addEventListener('mouseenter', slider._swiperMouseEnterHandler);
      slider.addEventListener('mouseleave', slider._swiperMouseLeaveHandler);
    });
  }

  function refreshInfiniteState() {
    const nextLink = document.querySelector('.infinite__scroll--button-wrap #ajaxcall');
    nextPageURL = nextLink ? nextLink.getAttribute('href') : null;
  }

  // function loadMoreProducts() {
  //   const mainGrid = document.querySelector('#product-grid');
  //   const loadMoreBtn = document.querySelector('.infinite__scroll--button-wrap #loadmore');
  //   if (!mainGrid || !nextPageURL || isInfiniteLoading) return;

  //   isInfiniteLoading = true;
  //   if (loadMoreBtn) {
  //     loadMoreBtn.disabled = true;
  //     loadMoreBtn.innerText = 'Loading...';
  //   }

  //   fetch(nextPageURL)
  //     .then((response) => {
  //       if (!response.ok) throw new Error(String(response.status));
  //       return response.text();
  //     })
  //     .then((text) => {
  //       const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
  //       const productGrid = parsedHTML.querySelector('#product-grid');
  //       const nextUrl = parsedHTML.querySelector('#ajaxcall');

  //       if (productGrid) {
  //         mainGrid.insertAdjacentHTML('beforeend', productGrid.innerHTML);
  //         bindColorSwatches();
  //         bindQuickAddOpeners();
  //         bindSizeAddToCart();
  //         initSwipers();
  //       }

  //       if (nextUrl) {
  //         nextPageURL = nextUrl.getAttribute('href');
  //         if (loadMoreBtn) {
  //           loadMoreBtn.disabled = false;
  //           loadMoreBtn.innerText = 'Load More';
  //         }
  //       } else {
  //         nextPageURL = null;
  //         if (loadMoreBtn) {
  //           loadMoreBtn.disabled = true;
  //           loadMoreBtn.innerText = 'No More Products';
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching data:', error);
  //       if (loadMoreBtn) {
  //         loadMoreBtn.disabled = false;
  //         loadMoreBtn.innerText = 'Load More';
  //       }
  //     })
  //     .finally(() => {
  //       isInfiniteLoading = false;
  //     });
  // }

  // function bindLoadMoreButton() {
  //   refreshInfiniteState();
  //   const loadMoreBtn = document.querySelector('.infinite__scroll--button-wrap #loadmore');
  //   if (!loadMoreBtn) return;

  //   if (!nextPageURL) {
  //     loadMoreBtn.disabled = true;
  //     loadMoreBtn.innerText = 'No More Products';
  //     return;
  //   }

  //   // Remove old listener if any by replacing the button with a clone
  //   const freshBtn = loadMoreBtn.cloneNode(true);
  //   loadMoreBtn.parentNode.replaceChild(freshBtn, loadMoreBtn);
  //   freshBtn.disabled = false;
  //   freshBtn.innerText = 'Load More';
  //   freshBtn.addEventListener('click', loadMoreProducts);
  // }

  // function initCollectionEnhancements() {
  //   bindColorSwatches();
  //   bindQuickAddOpeners();
  //   bindSizeAddToCart();
  //   initSwipers();
  //   bindLoadMoreButton(); // manual click only — no auto-scroll
  // }

  function scheduleReinit() {
    if (reinitScheduled) return;
    reinitScheduled = true;
    setTimeout(() => {
      reinitScheduled = false;
      initCollectionEnhancements();
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', initCollectionEnhancements);
  // window.addEventListener('collection:updated', scheduleReinit);
  window.addEventListener('popstate', scheduleReinit);
})();